import {isAoxTeam} from './matchday';

// Competition and season rules are shared by the fixtures list and the dashboard.
// Cup/friendly/temporary matches never count towards league points.
export const seasonForDate = (value) => {
  if (!value) return null;
  const match = /^(\d{4})-(\d{2})-\d{2}/.exec(String(value));
  if (!match) return null;
  const year = Number(match[1]);
  const start = Number(match[2]) >= 7 ? year : year - 1;
  return `${start}-${String(start + 1).slice(-2)}`;
};

export const isCupMatch = (match) => /κύπελλο|κυπελλο|\bcup\b/i.test(String(match?.tournament || ''));

export const isLeagueMatch = (match) => {
  if (!match || isCupMatch(match)) return false;
  if (['temporary', 'friendly', 'academy'].includes(String(match.source_type || '').toLowerCase())) return false;
  const tournament = String(match.tournament || '');
  const category = match.team_category || 'Senior';
  if (category === 'Senior') return /κατηγορία γυναικών|κατηγορια γυναικων|εθνική γυναικών/i.test(tournament);
  // Academy competitions have their own standings, not those of the Senior team.
  return /πρωτάθλημα|πρωταθλημα/i.test(tournament);
};

export const matchResult = (match) => {
  if (!match || match.status !== 'completed' || match.home_score == null || match.away_score == null) return null;
  if (!isAoxTeam(match.home_team) && !isAoxTeam(match.away_team)) return null;
  const home = isAoxTeam(match.home_team);
  const ours = Number(home ? match.home_score : match.away_score);
  const theirs = Number(home ? match.away_score : match.home_score);
  if (!Number.isFinite(ours) || !Number.isFinite(theirs)) return null;
  return ours > theirs ? 'W' : ours < theirs ? 'L' : 'D';
};

export const calculateAoxLeagueRecord = (matches,category,season) => {
  const completed = (matches || []).filter(match =>
    (match.team_category || 'Senior') === category &&
    seasonForDate(match.date) === season &&
    isLeagueMatch(match) && matchResult(match)
  );
  return completed.reduce((record,match) => {
    const ours = Number(isAoxTeam(match.home_team) ? match.home_score : match.away_score);
    const theirs = Number(isAoxTeam(match.home_team) ? match.away_score : match.home_score);
    record.played += 1;
    record.gf += ours;
    record.ga += theirs;
    if (ours > theirs) record.won += 1;
    else if (ours < theirs) record.lost += 1;
    else record.drawn += 1;
    record.points = record.won * 3 + record.drawn;
    return record;
  },{played:0,won:0,drawn:0,lost:0,gf:0,ga:0,points:0});
};

// Prefer canonical completed AOX league matches when the saved standings are
// behind. Other clubs remain as imported from the league's standings table.
export const reconcileLeagueStandings = (standings,matches,category,season) => {
  const rows = (standings || []).filter(row =>
    (row.team_category || 'Senior') === category && row.season_year === season
  );
  const aox = rows.find(row => isAoxTeam(row.team));
  if (!aox) return rows.slice().sort((a,b) => Number(a.position) - Number(b.position));
  const record = calculateAoxLeagueRecord(matches,category,season);
  const shouldReconcile = record.played > 0 && record.played >= Number(aox.played || 0);
  const updated = rows.map(row => isAoxTeam(row.team) && shouldReconcile ? {...row,...record} : row);
  if (!shouldReconcile) return updated.slice().sort((a,b) => Number(a.position) - Number(b.position));
  const sorted = updated.slice().sort((a,b) =>
    Number(b.points || 0) - Number(a.points || 0) ||
    (Number(b.gf || 0)-Number(b.ga || 0)) - (Number(a.gf || 0)-Number(a.ga || 0)) ||
    Number(b.gf || 0) - Number(a.gf || 0) ||
    String(a.team).localeCompare(String(b.team),'el')
  );
  let rank = 0;
  return sorted.map((row,index) => {
    const previous = sorted[index-1];
    const tied = previous && Number(previous.points || 0)===Number(row.points || 0) &&
      Number(previous.gf || 0)-Number(previous.ga || 0)===Number(row.gf || 0)-Number(row.ga || 0) &&
      Number(previous.gf || 0)===Number(row.gf || 0);
    if (!tied) rank = index + 1;
    return {...row,position:rank};
  });
};
